import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from './store';
import { Navigate, Outlet } from 'react-router-dom';

const AppPermission = ({ accessKey, all, view }: any) => {
	const roleandPermission = useSelector(
		(state: RootState) => state.auth.roleandPermission
	);

	const data = roleandPermission?.find((data: any) => data?.module?.key == accessKey);
	// console.log(data);

	useEffect(() => {
		console.log();
	}, [roleandPermission]);

	return (data?.all && all) || (data?.view && view) ? (
		<Outlet />
	) : (
		<Navigate to='/dashboard' />
	);
};

export default AppPermission;
